<template>

    <section>

        <!-- ここから -->

        <div class="dm_component">

            <div class="md_common-bl">
                <div class="inner">

                    <!--:::::::::::::::::::::::::::::::::::::::::::::::
                        Register
                    :::::::::::::::::::::::::::::::::::::::::::::::::-->
                    <div class="register-wrap news_component">
                        <form v-on:submit.prevent="dmPost">
                            <!-- PostTitle -->
                            <div class="post-title">
                                <!-- Title -->
                                <div class="item form_text _big">
                                    <div class="input-row">
                                        <input type="text" maxlength="250" id="dm-title" v-model="title" required>
                                    </div>
                                    <label for="dm-title"><span>タイトル</span></label>
                                </div>
                            </div>
                            <!-- PostBody -->
                            <div class="post-body">
                                <div class="item form_textarea">
                                    <textarea maxlength="250" v-model="text" placeholder="" required></textarea>
                                </div>
                            </div>
                        </form>

                        <!--btn-link-wrap-->
                        <div class="btn_link-wrap">

                            <!--LinkBtn - キャンセル -->
                            <button v-on:click="draftDmPost" class="btn_link _cancel md_icon-text">
                                <div class="inner">
                                    <span><div class="icon"><SvgIconEdit /></div>下書き保存</span>
                                </div>
                            </button>

                            <!--LinkBtn - 決定アイコン -->
                            <button class="btn_link md_icon-text _white">
                                <div class="inner">
                                    <span><div class="icon"><SvgIconCheck /></div>確認</span>
                                </div>
                            </button>

                        </div><!--/.btn-link-wrap-->

                    </div><!-- /.register-wrap -->


                    <!--:::::::::::::::::::::::::::::::::::::::::::::::
                        Preview
                    :::::::::::::::::::::::::::::::::::::::::::::::::-->
                    <div class="preview-wrap talk_component">

                        <h3><span>プレビュー</span></h3>

                        <div class="wrap">
                            <div class="talk-inner">

                                <!-- Bubble -->
                                <div class="bubble-item">
                                    <div class="avatar-wrap">
                                        <img src="/img/smp/end-user-shop1.jpg" alt="" class="avatar">
                                    </div>
                                    <div class="bubble-wrap">
                                        <div class="bubble-body">
                                            <p><span>{{text}}</span></p>
                                        </div>
                                        <time>2022/12/12 18:00</time>
                                    </div>
                                </div>

                            </div><!-- /TalkInner -->
                        </div><!-- /Wrap -->

                    </div><!-- /.Preview-wrap -->
                    <!--:::::::::::::::::::::::::::::::::::::::::::::::
                        /Preview
                    :::::::::::::::::::::::::::::::::::::::::::::::::-->

                </div><!-- /.inner -->
            </div><!-- /.md_common-bl -->

        </div><!-- /.dm_component -->

    <!-- ここまで -->

    </section>

</template>


<script>
    //Svg
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'
    import SvgIconEdit from '@/components/EndUser/svg/SvgIconEdit'

    export default {
        components: {
            //Svg
            SvgIconCheck,
            SvgIconEdit,
        },
    }
</script>
